import Decimal from 'decimal.js';
import { formatNumber } from '../utils/formatters';

export function formatCurrency(value: Decimal | number, toFixed = 2, suffix = 'PLN'): string {
  const decimalValue = value instanceof Decimal ? value : new Decimal(value);
  const formatted = formatNumber(decimalValue, toFixed, true);
  return `${formatted} ${suffix}`;
}

const toDecimal = (value: Decimal | number): Decimal => value instanceof Decimal ? value : new Decimal(value);

export function formatCurrencyWithoutCode(value: Decimal | number, toFixed = 2): string {
  const decimalValue = toDecimal(value);
  return formatNumber(decimalValue, toFixed, true);
}

export function formatCurrencyWithoutTrailingZerosAndCode(value: Decimal | number, toFixed = 2): string {
  const decimalValue = toDecimal(value);
  return formatNumber(decimalValue, toFixed, false);
}

export function formatCurrencyWholeNumber(value: Decimal | number): string {
  const decimalValue = toDecimal(value);
  const rounded = decimalValue.round();
  return formatNumber(rounded, 0, true);
}
